import axios from 'axios';

const PROJECTS_BASE_URL = `${window.__RUNTIME_CONFIG__?.REACT_APP_DATA_MANAGER}/project`;

export const getPmdProjects = async (status) =>
  axios.get(`${PROJECTS_BASE_URL}/all`, {
    ...(status && {
      ...{
        params: {
          status,
        },
      },
    }),
  });
